import React, { useEffect, useState } from 'react';
import { decodeBase64, determineStringType, StringType } from '../../../utils/stringUtils';
import { Button } from 'react-bootstrap';
import BzmIcon from '../../icons/BzmIcon';
import _ from 'lodash';
import format from 'xml-formatter';

interface ResponseBodyProps {
  body?: string;
}

const ResponseBody = ({ body }: ResponseBodyProps) => {
  useEffect(() => {
    if (!_.isNil(body)) {
      const bodyContent = decodeBase64(body);
      setResponseBody(bodyContent);
      setBodyType(determineStringType(bodyContent));
    } else {
      setResponseBody(undefined);
      setBodyType(undefined);
    }
  }, [body]);

  const [responseBody, setResponseBody] = React.useState<string>();
  const [bodyType, setBodyType] = useState<StringType>();
  const [isPreview, setIsPreview] = React.useState<boolean>(false);
  const [isFormatted, setIsFormatted] = React.useState<boolean>(false);

  const renderResponseBody = () => {
    if (_.isNil(responseBody) || responseBody === '') {
      return <span className={'text-muted'}>No response body available</span>;
    }

    if (isPreview) {
      return (
        <iframe
          style={{ border: 0, minHeight: '500px' }}
          title={'Response Body Preview'}
          srcDoc={responseBody}
          width={'100%'}
        ></iframe>
      );
    } else {
      return (
        <code className={'text-black'} style={{ whiteSpace: 'pre-wrap' }}>
          {responseBody}
        </code>
      );
    }
  };

  const formatBody = () => {
    // Reset to original body if formatted already
    if (isFormatted) {
      setResponseBody(decodeBase64(body));
      setIsFormatted(false);
      return;
    }

    if (bodyType === 'JSON') {
      try {
        const json = JSON.parse(responseBody || '');
        setResponseBody(JSON.stringify(json, null, 4));
        setIsFormatted(true);
      } catch (error) {
        console.error('Failed to format JSON body:', error);
      }
    } else if (bodyType === 'HTML') {
      const formattedHtml = format(responseBody || '');
      setResponseBody(formattedHtml);
    } else {
      console.warn('Formatting not supported for this body type:', bodyType);
    }

    setIsFormatted(!isFormatted);
  };

  return (
    <div>
      {!_.isNil(body) && (
        <div className={'mb-3'}>
          {bodyType === 'HTML' && (
            <Button
              variant={'link'}
              className={'no-hover text-decoration-none'}
              onClick={() => setIsPreview(!isPreview)}
            >
              <BzmIcon
                variant={isPreview ? 'icon-bzm-hide' : 'icon-bzm-show'}
                className={'mr-2'}
                title={'Show Preview'}
              />
              {isPreview ? 'Hide Preview' : 'Show Preview'}
            </Button>
          )}

          {!isPreview && (bodyType === 'JSON' || bodyType === 'HTML') && (
            <Button variant={'link'} className={'no-hover text-decoration-none'} onClick={() => formatBody()}>
              <span className={'mr-2'}>{isFormatted ? '}{' : '{}'}</span>
              {isFormatted ? 'Show Raw data' : 'Format Body'}
            </Button>
          )}
        </div>
      )}
      <div>{_.isNil(body) ? 'No response body available' : renderResponseBody()}</div>
    </div>
  );
};

export default ResponseBody;
